import React from 'react';

const UnsubscribeSuccess: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-8 text-center">
        <div className="text-green-500 text-5xl mb-4">✓</div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Successfully Unsubscribed</h1>
        <p className="text-gray-600">
          You have been unsubscribed from our mailing list. You will no longer receive marketing emails from us.
        </p>
      </div>
    </div>
  );
};

export default UnsubscribeSuccess;
